import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { InputDatePickerComponent } from './input-date-picker.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
  ],
  declarations: [InputDatePickerComponent],
  exports: [InputDatePickerComponent],
})
export class InputDatePickerModule {}
